import React from 'react';
import Icon from 'screens/shared/icon';
import Input from 'screens/shared/form/input-field';

export default ({
  value = '', onChange, error, title, name,
}) => {
  const fileChangeHandler = (e) => {
    const { files } = e.target;
    const reader = new window.FileReader();
    if (files[0]) reader.readAsBinaryString(files[0]);
    reader.onload = function loaddata(re) {
      onChange(re.target.result);
    };
  };

  function inputHandler(newValue) {
    onChange(newValue);
  }

  return (
    <>
      <div>
        <label htmlFor={`import-file-${name}`} className="float-right m-b-20- relative top-12 left-10- pointer" style={{ zIndex: 1000 }}>
          <span className="color-link">
            <Icon name="cloud-upload-alt" className="font-16 m-r-5" />
              Import File
          </span>

          <input type="file" onChange={fileChangeHandler} style={{ display: 'none' }} id={`import-file-${name}`} />
        </label>

        <div>
          <Input
            value={value}
            onChange={inputHandler}
            multiline
            minRows="4"
            maxRows="10"
            style={{ width: '100%' }}
            label={title}
            error={error}
          />
        </div>
      </div>
    </>
  );
};
